import axios from "axios";

// Ensure REACT_APP_API_URL is set in .env
export const api = process.env.REACT_APP_API_URL;
export const apiKey = process.env.REACT_GOOGLE_API_KEY;
export const axiosInstance = axios.create({
  baseURL: api,
  headers: {
    "Content-Type": "application/json",
  },
});

export const register = async (data) => {
  try {
    const ipResponse = await axios.get("https://api.ipify.org?format=json");
    const clientIP = ipResponse.data.ip;

    const userAgent = navigator.userAgent;

    const registrationData = {
      ...data,
      ip: clientIP,
      userAgent: userAgent,
    };

    const response = await axiosInstance.post("/user/signup", registrationData);
    return response;
  } catch (error) {
    console.error("Registration Error:", error);
    throw error;
  }
};

export const login = async (data) => {
  try {
    // Get client IP
    const ipResponse = await axios.get("https://api.ipify.org?format=json");
    const clientIP = ipResponse.data.ip;

    // Get browser User Agent
    const userAgent = navigator.userAgent;

    // Add IP and User Agent to login data
    const loginData = {
      ...data,
      ip: clientIP,
      userAgent: userAgent,
    };

    const response = await axiosInstance.post("/user/login", loginData);
    return response;
  } catch (error) {
    console.error("Login Error:", error);
    throw error;
  }
};

export const createDraft = async (id) => {
  try {
    const response = await axiosInstance.post(`/development/addDraft/${id}`);
    return response; // Successful response
  } catch (error) {
    console.error("Create Draft Error:", error);
    throw error; // Rethrow the error to be handled by the calling function
  }
};

export const createDevelopment = async (data) => {
  try {
    // Creamos una nueva instancia de FormData
    const formData = new FormData();

    // Añadimos los campos del modelo Development al FormData
    formData.append("name", data.name);
    formData.append("delivery_date", data.delivery_date);
    formData.append("address", data.address);
    formData.append("latitude", data.latitude);
    formData.append("longitude", data.longitude);
    formData.append("description", data.description || ""); // El campo description puede ser opcional
    formData.append("location_name", data.location_name);
    formData.append("location_info", data.location_info || ""); // Campo opcional
    formData.append("seller_name", data.seller_name);
    formData.append("seller_info", data.seller_info || ""); // Campo opcional
    formData.append("contact_number", data.contact_number);
    formData.append("contact_email", data.contact_email || ""); // Campo opcional
    formData.append("meta_description", data.meta_description || ""); // Campo opcional
    formData.append("is_private", data.is_private);
    formData.append("hasBuildingLicense", data.hasBuildingLicense || false);
    formData.append("user_id", data.user_id);

    // Verificamos si la imagen existe antes de agregarla
    if (data.image && data.image[0]) {
      formData.append("image", data.image[0]);
    } else {
      throw new Error("No se ha proporcionado una imagen válida.");
    }

    // Realizamos la solicitud POST usando axios
    const response = await axiosInstance.post("/development/add", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    // Retornamos la respuesta para su uso posterior
    return response.data;
  } catch (error) {
    // Capturamos y mostramos cualquier error
    console.error("Error al crear el desarrollo:", error.message);
    throw new Error(error.response?.data?.message || error.message); // Proporcionamos un mensaje de error claro
  }
};

export const addAmenityToDevelopment = async (data) => {
  try {
    const formData = {
      model_id: data.id,
      amenities: data.amenities,
    };

    const response = await axiosInstance.post(
      "/propertieModel/createamenity",
      formData
    );
    return response.data;
  } catch (error) {
    console.error("Error al agregar amenity al desarrollo:", error.message);
    throw new Error(error.response?.data?.message || error.message);
  }
};
export const updateDevelopment = async (id, data) => {
  try {
    // console.log(data);
    console.log(data);

    const formData = new FormData();

    // Añadimos todos los campos que pueden ser actualizados
    if (data.name) formData.append("name", data.name);
    if (data.delivery_date) formData.append("delivery_date", data.delivery_date);
    if (data.address) formData.append("address", data.address);
    if (data.latitude) formData.append("latitude", data.latitude);
    if (data.longitude) formData.append("longitude", data.longitude);
    if (data.description !== undefined) formData.append("description", data.description);
    if (data.location_name) formData.append("location_name", data.location_name);
    if (data.location_info !== undefined) formData.append("location_info", data.location_info);
    if (data.seller_name) formData.append("seller_name", data.seller_name);
    if (data.seller_info !== undefined) formData.append("seller_info", data.seller_info);
    if (data.contact_number) formData.append("contact_number", data.contact_number);
    if (data.contact_email !== undefined) formData.append("contact_email", data.contact_email);
    if (data.meta_description !== undefined) formData.append("meta_description", data.meta_description);
    if (data.applied_payment_plans !== undefined) formData.append("applied_payment_plans", data.applied_payment_plans);
    if (data.is_private !== undefined) formData.append("is_private", data.is_private);
    if (data.hasBuildingLicense !== undefined) formData.append("hasBuildingLicense", data.hasBuildingLicense);
    if (data.status) formData.append("status", data.status);

    // Solo agregamos la imagen si se proporciona una nueva
    if (data.image && data.image[0]) {
      formData.append("image", data.image[0]);
    }
    if (data.mainImage && data.mainImage[0]) {
      formData.append("mainImage", data.mainImage[0]);
    }
    
    const response = await axiosInstance.patch(
      `/development/update/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    // console.log(response.data);

    return response.data;
  } catch (error) {
    console.error("Error al actualizar el desarrollo:", error.message);
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const getDevelopmentById = async (id) => {
  try {
    const response = await axiosInstance.get(`/development/read/${id}`);
    return response;
  } catch (error) {
    console.error("Error al obtener el desarrollo:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const getDevelopmentByUserId = async (id) => {
  try {
    const response = await axiosInstance.get(`/development/readbyuser/${id}`);
    // console.log("Developmenst por usuarios", response);
    return response;
  } catch (error) {
    console.error("Error al obtener los desarrollos:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const countDevelopmentsByUserId = async (id) => {
  try {
    const response = await axiosInstance.get(`/development/count/${id}`);
    // console.log("Count Developments", response);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los desarrollos:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const userPaymentPlans = async (id) => {
  try {
    const response = await axiosInstance.get(`/paymentplan/get/user/${id}`);
    // const response = await axiosInstance.get(`/paymentplan/get/user/3`);
    // console.log("pp:", response.data.message);
    return response.data.message;
  } catch (error) {
    console.error("Error al obtener los planes de pago del usuario:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const updateNemu = async (id, data) => {
  try {
    // Crear un objeto FormData
    const formData = new FormData();

    // Agregar los datos al FormData
    formData.append("descripcion", data.descripcion);
    if (data.image) formData.append("image", data.image[0]); // Aquí se asume que `data.image` es un objeto de archivo (File)

    // Enviar la solicitud con axios
    const response = await axiosInstance.patch(
      `/user/profile/nemu/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Especificar que estamos enviando datos como form-data
        },
      }
    );

    return response; // Respuesta exitosa
  } catch (error) {
    console.error("Update Error:", error);
    throw error; // Rethrow para manejarlo desde la función llamante
  }
};

export const verifyToken = async () => {
  try {
    const token = localStorage.getItem("token"); // O el lugar donde almacenes el token
    console.log(token);
    
    const response = await axiosInstance.post(
      "/user/verify-token",
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response;
  } catch (error) {
    console.error("Token Verification Error:", error);
    throw error;
  }
};

export const profileAcknowledge = async (id) => {
  try {
    const response = await axiosInstance.get(`user/acknowledge/user/${id}`);
    return response; // Successful response
  } catch (error) {
    console.error("Profile Acknowledge Error:", error);
    throw error;
  }
};

export const createAcknowledgment = async (data) => {
  try {
    const formData = new FormData();
    // Agregar todos los campos al FormData
    formData.append("user_id", data.user_id);
    formData.append("name", data.name);
    formData.append("acquisition_date", data.acquisition_date);
    formData.append("descripcion", data.description);
    formData.append("verify", data.verify);

    // Agregar la imagen al FormData
    if (data.image) {
      formData.append("image", data.image[0]); // Asegúrate de que `data.image` sea un `File` o provenga de un input file
    }

    console.log(
      "FormData",
      formData.get("user_id"),
      formData.get("name"),
      formData.get("acquisition_date"),
      formData.get("descripcion"),
      formData.get("verify"),
      formData.get("image")
    );

    // Realizar la solicitud con Axios
    const response = await axiosInstance.post("user/acknowledge", formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Indica que estamos enviando datos de tipo FormData
      },
    });

    return response; // Respuesta exitosa
  } catch (error) {
    console.error("Create Acknowledgment Error:", error);
    throw error; // Relanzar el error para manejarlo en el código que llama esta función
  }
};

export const deleteAcknowledge = async (id) => {
  try {
    const response = await axiosInstance.post(`user/acknowledge/delete/${id}`);
    return response; // Successful response
  } catch (error) {
    console.error("Delete Acknowledgment Error:", error);
    throw error;
  }
};

export const updateAcknowledge = async (data, id) => {
  console.log("Update Acknowledge", data);
  console.log("Update Acknowledge", id);
  try {
    const formData = new FormData();
    // Agregar todos los campos al FormData
    formData.append("user_id", data.user_id);
    formData.append("name", data.name);
    formData.append("acquisition_date", data.acquisition_date);
    formData.append("descripcion", data.description);
    formData.append("verify", data.verify);

    // Agregar la imagen al FormData
    if (data.image) {
      formData.append("image", data.image[0]); // Asegúrate de que `data.image` sea un `File` o provenga de un input file
    }

    console.log(
      "FormData",
      formData.get("user_id"),
      formData.get("name"),
      formData.get("acquisition_date"),
      formData.get("descripcion"),
      formData.get("verify"),
      formData.get("image")
    );

    const response = await axiosInstance.patch(
      `user/acknowledge/update/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Indica que estamos enviando datos de tipo FormData
        },
      }
    );
    console.log("Update Acknowledge", response);
    return response; // Successful response
  } catch (error) {
    console.error("Delete Acknowledgment Error:", error);
    throw error;
  }
};

export const getAllCustomers = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axiosInstance.get("/customer/admin/all", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error("Error al obtener clientes:", error);
    throw error;
  }
};

export const adminResetFingerprint = async (customerId) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axiosInstance.patch(
      `/customer/admin/reset-fingerprint/${customerId}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response;
  } catch (error) {
    console.error("Error al resetear fingerprint:", error);
    throw error;
  }
};

export const enterpriseProfile = async (id) => {
  try {
    const response = await axiosInstance.get(`/user/profile/${id}`);
    // console.log(response);
    return response; // Successful response
  } catch (error) {
    console.error("Enterprise Profile Error:", error);
    throw error;
  }
};

export const updateEnterpriseProfile = async (id, data) => {
  try {
    const response = await axiosInstance.patch(`/user/profile/${id}`, data);
    return response; // Successful response
  } catch (error) {
    console.error("Update Enterprise Profile Error:", error);
    throw error;
  }
};
